import Config from './config';

export function certificateImageUrl(key: string): string {
    return new URL(`${Config.apiRoot.replace(/\/+$/, '')}/api/certificate.php?${new URLSearchParams({ key })}`, window.location.origin).href;
}

export function certificatePublicUrl(key: string): string {
    return new URL(`/certificate/${encodeURIComponent(key)}`, window.location.origin).href;
}
